@import '../../style/index';

:host {
  display: block;

  // padding-top: rem-calc(70px);
  @include xlarge-up {
    padding-top: rem-calc(150px);
  }
}

:host(.custom-container) {
  @include xlarge-up {
    padding-top: rem-calc(90px);
  }
}

.full {
  @include xlarge-up {
    padding-top: rem-calc(150px);
  }
}

.custom {
  padding-top: 0;
}

.aussetzung-container {
  border-bottom: 3px solid var(--colors-primary-base);

  rcm-container {
    padding: var(--spacings-l) 0;
    position: relative;

    .close-aussetzung {
      display: block;
      position: absolute;
      right: var(--spacings-l);
      top: var(--spacings-l);
      cursor: pointer;
      z-index: 10;
    }
  }
}

:host(.padded) {
  @include xlarge-up {
    padding-top: rem-calc(150px);
  }
}
